import React, { useEffect, useState } from "react";
import { ReactComponent as Star } from "../../assets/icons/star.svg";
import { useSelector, useDispatch } from "react-redux";
import { tutorActions } from "../../utils/store/selectedTutor.js";

function TutorCard({ tutor, thisUser }) {
  const [thisUserhasReviewedThisTutor, setThisUserhasReviewedThisTutor] =
    useState(false);
  const selectedTutor = useSelector((state) => state.selectedTutor.tutor);
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      const cards = document.querySelectorAll(".cards");
      for (const card of cards) {
        card.style.width = "19em";
      }
    }, 70);
  }, []);

  const setSelectedTutor = (tutor) => {
    dispatch(tutorActions.set(tutor));
    console.log(selectedTutor);
  };

  useEffect(() => {
    for (const reviewedID of tutor.reviews.reviewers) {
      if (reviewedID?.id === thisUser?.id) {
        setThisUserhasReviewedThisTutor(true);
      }
    }
  }, [selectedTutor]);

  if (!tutor) return;

  return (
    <div
      className={`pl-[.25em] cards inline-block transition-all ease-out w-[0px] pt-[1.2em] duration-[800ms] mr-2 mt-5 ${
        thisUserhasReviewedThisTutor
          ? "hover:bg-gray-200"
          : "hover:bg-[#c0a964d0]"
      } rounded-[20px] mx-1 ${
        selectedTutor && selectedTutor.id === tutor.id && "bg-[#c7ab57c2]"
      }`}
    >
      <div
        className={`relative w-[16em] z-20 h-fit mx-5 rounded-xl shadow-lg shadow-[#2727275e] pb-5 transition duration-500 ease-in-out cursor-pointer ${
          selectedTutor && selectedTutor.id === tutor.id && "-translate-y-5"
        } ${
          thisUserhasReviewedThisTutor
            ? "opacity-70 cursor-not-allowed"
            : "hover:-translate-y-8"
        }`}
        onClick={() => {
          if (thisUserhasReviewedThisTutor) return;
          setSelectedTutor(tutor);
        }}
      >
        {thisUserhasReviewedThisTutor && (
          <p className="absolute text-lg top-[-3em] left-[50%] -translate-x-[50%] font-semibold text-gray-800 opacity-80">
            You've already reviewed this tutor
          </p>
        )}
        <img
          alt="Profile icon of the tutor"
          src={tutor.profileImagePath}
          className="flex-1 object-cover rounded-t-xl h-[20em] w-[16em]"
        />
        <div className="h-[6em] " />
        <div className="flex flex-col items-center py-6 px-4 w-[17em] left-[50%] -translate-x-[50%] mx-auto absolute bottom-0 bg-[#252525] rounded-b-xl rounded-t-xl">
          <p className="text-[1.4em] font-semibold text-white ">
            {tutor.firstName} {tutor.lastName}
          </p>
          <div className="flex gap-1 items-center m-1 mb-2">
            <Star
              fill="#C0A964"
              width={`${tutor.rating !== 0 ? "15" : "14"}`}
            />
            {tutor.rating !== 0 ? (
              <p className="text-white font-semibold">{tutor.rating}</p>
            ) : (
              <p className="text-white font-medium text-sm">No reviews</p>
            )}
          </div>
          <div className="flex">
            <p className="text-white font-medium whitespace-normal text-center text-sm">
              {tutor.specialization.map(
                (s) =>
                  s +
                  (tutor.specialization.indexOf(s) !==
                  tutor.specialization.length - 1
                    ? " • "
                    : "")
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TutorCard;
